<template>
  <div class="syotei-work-week-days edit-item" v-if="editingData">

    <div class="head"><b>所定労働日数（週）</b></div>
    <div class="data flex flex-align-center">
      <div class="days">
        <input-text v-model="editingData.syotei_work_week_days" class="small" :type="'number'" inputmode="numeric" :isCastNumber="true" min="0"
          :error="getError(editingData, 'syotei_work_week_days')" :disabled="disabled"></input-text>
        <p class="current-data">{{ currentData?.syotei_work_week_days }}</p>
      </div>
      <p class="scale">日</p>
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();

    return {
      getError,
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
